import { queryOptions, useQuery } from '@tanstack/react-query';
import { DeliveryService } from '../generated';
import { blobToDataURL } from '../common';
import { ApiError } from '../../components/ApiLoadingGuard/ApiLoadingGuard';

export const deliveryImageKeys = {
  base: () => ['deliveryImage'] as const,
  read: ({ jobsiteId, deliveryId, imageId }: DeliveryImageOptionsProps) =>
    [...deliveryImageKeys.base(), jobsiteId, deliveryId, imageId] as const,
};

export interface DeliveryImageOptionsProps {
  jobsiteId: string | undefined;
  deliveryId: string | undefined;
  imageId: string | undefined;
}

export function deliveryImageOptions({ jobsiteId, deliveryId, imageId }: DeliveryImageOptionsProps) {
  return queryOptions<string, ApiError>({
    queryKey: deliveryImageKeys.read({ jobsiteId, deliveryId, imageId }),
    queryFn: async () => {
      if (!jobsiteId || !deliveryId || !imageId) {
        throw new Error('jobsiteId, deliveryId, and imageId are required');
      }

      const response = await DeliveryService.deliveryControllerGetDeliveryImage({
        path: {
          jobsiteId,
          deliveryId,
          imageId,
        },
      });

      if (response.data !== undefined) {
        return await blobToDataURL(response.data as Blob);
      } else {
        throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!jobsiteId && !!deliveryId && !!imageId,
  });
}

export function useDeliveryImage(props: DeliveryImageOptionsProps) {
  return useQuery(deliveryImageOptions(props));
}
